import {
  CompanyService,
  CompanyServiceGroup,
  CompanyServiceTicketGroup, CompanyServiceTicketGroupBase,
  CompanyServiceTicketGroupListItem
} from '@src/@data/types/services';

const compare = (a: number, b: number, desc = false): number => {
  const result = a > b ? 1 : a < b ? -1 : 0;
  return desc ? -result : result;
};

export const defaultServiceSort = (
  s1: Pick<CompanyService, 'title' | 'id'>,
  s2: Pick<CompanyService, 'title' | 'id'>
): number => {
  let result = s1.title.localeCompare(s2.title, undefined, { numeric: true });
  if (result === 0) {
    result = s1.id.localeCompare(s2.id);
  }
  return result;
};

export const defaultServiceGroupSort = (
  g1: CompanyServiceGroup,
  g2: CompanyServiceGroup
): number => {
  let result = compare(g2.priority, g1.priority);
  if (result === 0) {
    result = g1.title.localeCompare(g2.title, undefined, { numeric: true });
  }
  if (result === 0) {
    result = g1.id.localeCompare(g2.id);
  }
  return result;
};

export const defaultServiceTicketGroupSort = (
    g1: CompanyServiceTicketGroupBase,
    g2: CompanyServiceTicketGroupBase
): number => {
  let result = compare(g2.priority, g1.priority);
  if (result === 0) {
    result = g1.priority - g2.priority;
  }
  if (result === 0) {
    result = g1.id.localeCompare(g2.id);
  }
  return result;
};